module.exports = __webpack_public_path__ + "img/30-year-nozzle.26888b69.png";